import styled from 'astroturf/react'
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { BareButton } from '@calendly/ui/components/bare-button'
const colorSurfaceAction = 'var(--colorSurfaceAction, var(--coreColorBlue600))'
const colorSurfaceDestructive = 'var(--colorSurfaceDestructive, var(--coreColorRed600))'
const colorTextInverseStandard = 'var(--colorTextInverseStandard, var(--coreColorNeutral0))'
const fontSizeLarge = 'var(--fontSizeLarge, 1rem)'

import { useI18n } from 'locales'
import { redirectToAuthorizeUrl } from 'actions/omniauth'
import { getOmniAuthPath } from 'services/authentication_service'
import RoundIcon from 'components/round_icon'

import Header from './header'
import NotMeLink from './not_me_link'
import QuitLink from './quit_link'
import { Centered } from './styles'
import _LoginButton from "external-LoginButton.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/mutual_availability_notice/login/external.js?styleId=LoginButton";


const LoginButton = /*#__PURE__*/styled(BareButton, null, {
  displayName: "LoginButton",
  styles: _LoginButton
})

const LOGIN_BRAND_LOGO = {
  google: 'google',
  outlook: 'microsoft-outlook',
}

export default ({ closePopup, authenticationData, setAuthenticationData }) => {
  const { i18n } = useI18n()
  const dispatch = useDispatch()
  const { provider, title: authTitle, name: authName } = authenticationData.authentication
  const path = getOmniAuthPath(provider, 'login', { email: authenticationData.email, booking_redirect: window.location.href })

  const providerType = authName === 'office365' ? 'outlook' : authName

  const login = useCallback(
    () => {
      dispatch(redirectToAuthorizeUrl(path))
    },
    [path, dispatch]
  )

  return (
    <>
      <Header>{i18n.t('booking.mutual_availability.login.welcome_back', { email: authenticationData.email })}</Header>
      <NotMeLink onClick={() => setAuthenticationData(null)} />
      <Centered>
        <LoginButton
          size="large"
          provider={providerType}
          onClick={login}
        >
          {providerType !== 'saml' && (
            <RoundIcon
              name={LOGIN_BRAND_LOGO[providerType] ?? providerType}
              style={{ marginRight: 15, width: 33, height: 33, boxShadow: 'none' }}
            />
          )}
          {i18n.t('publisher.auth.login.login_with', { provider: authTitle })}
        </LoginButton>
        <QuitLink closePopup={closePopup} />
      </Centered>
    </>
  )
}
